import { useMemo } from 'react';
import { LinearProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { BottomNavigation } from './bottom-navigation.component';
import { useBottomNavigationController } from './use-bottom-navigation-controller.hook';

export type BottomNavigationControllerProps = {
  /** When true, renders a thin progress bar above the navigation. Use for any non-blocking
   *  "data is in flight" affordance - pull-to-refresh, background revalidation, etc. */
  loading?: boolean;
};

export const BottomNavigationController = ({ loading = false }: BottomNavigationControllerProps) => {
  const location = useLocation();
  const { tabs } = useBottomNavigationController();
  const activeTab = useMemo(
    () => tabs.find((tab) => location.pathname.startsWith(tab.routerPath)),
    [location.pathname, tabs],
  );

  return (
    <>
      {loading && <LinearProgress sx={{ opacity: 0.8 }} />}
      <BottomNavigation value={activeTab?.value ?? tabs[0].value} tabs={tabs} />
    </>
  );
};
